import React from "react";
import { useToast } from "@chakra-ui/react";

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Return a element which supports the toast.
 *
 * @param {React.ElementType} Component The component.
 * @returns {(props: any) => JSX.Element} The function for a component with toast properties.
 */
export function withToast(
  Component: React.ElementType,
): (props: any) => JSX.Element 
{
  /* eslint-enable @typescript-eslint/no-explicit-any */
  /**
   * Get a component with toast properties.
   *
   * @param {any} props The toast properties.
   * @returns {any} The component which uses toast properties.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function ComponentWithToastProp(props: any): JSX.Element 
  {
    const toast = useToast();

    return <Component {...props} toast={toast} />;
  }

  return ComponentWithToastProp;
}